// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Header_navbar__1qfYE","logo":"Header_logo__2iVyL","border":"Header_border__1YRnH","theme":"Header_theme__23-xK","logout":"Header_logout__3Rd_K"};